import React from 'react';
import { Music, RefreshCw, Zap, DollarSign } from 'lucide-react';
import { features } from '../mock';

const iconMap = {
  0: Music,
  1: RefreshCw,
  2: Zap,
  3: DollarSign
};

const Features = () => {
  return (
    <section id="features" className="py-20 bg-gradient-to-b from-black to-gray-900 relative overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => {
            const Icon = iconMap[index];
            return (
              <div
                key={feature.id}
                className="group relative bg-gradient-to-br from-gray-900 to-black border border-orange-500/30 rounded-xl p-8 hover:border-orange-500 transition-all duration-300 hover:shadow-2xl hover:shadow-orange-500/20 hover:-translate-y-2 aspect-square flex flex-col items-center justify-center"
              >
                {/* Icon */}
                <div className="mb-4 flex justify-center">
                  <div className="p-4 bg-gradient-to-br from-orange-500 to-red-600 rounded-full shadow-lg group-hover:shadow-orange-500/50 transition-shadow">
                    <Icon className="h-8 w-8 text-white" />
                  </div>
                </div>
                
                {/* Content */}
                <h3 className="text-xl font-bold text-center mb-3 text-orange-400 group-hover:text-orange-300 transition-colors">
                  {feature.title}
                </h3>
                <p className="text-gray-400 text-center text-sm leading-relaxed">
                  {feature.description}
                </p>

                {/* Glow effect on hover */}
                <div className="absolute inset-0 bg-gradient-to-br from-orange-500/0 to-red-600/0 group-hover:from-orange-500/5 group-hover:to-red-600/5 rounded-xl transition-all duration-300"></div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;